import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Group } from '../entities/schema/group.entity';
import { Wettbewerber } from '../entities/schema/wettbewerber.entity';
import { WettbewerberPreisGroup } from '../entities/schema/wettbewerberpreisgroup.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
import { WettbewerberPreis } from '../entities/wettbewerb/wettbewerberpreis.entity';
//#endregion

@Injectable()
export class WettbewerberPreisService extends ODataEntityService<WettbewerberPreis> {
  constructor(protected client: ODataClient) {
    super(client, 'WettbewerberPreis', 'entities.wettbewerb.WettbewerberPreis');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public group(entity: EntityKey<WettbewerberPreis>): ODataNavigationPropertyResource<Group> {
    return this.entity(entity).navigationProperty<Group>('group');
  }
  public status(entity: EntityKey<WettbewerberPreis>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<WettbewerberPreis>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  public wettbewerber(entity: EntityKey<WettbewerberPreis>): ODataNavigationPropertyResource<Wettbewerber> {
    return this.entity(entity).navigationProperty<Wettbewerber>('wettbewerber');
  }
  public wettbewerberPreisGroups(entity: EntityKey<WettbewerberPreis>): ODataNavigationPropertyResource<WettbewerberPreisGroup> {
    return this.entity(entity).navigationProperty<WettbewerberPreisGroup>('wettbewerberPreisGroups');
  }
  //#endregion
}
